export default{
    namespaced: true,
    
    state() {
        return {
            storage: null,
            visibleStorage: null,
            activeStorageId: null,
            dataToSend: null
        }
    },
    mutations: {
        setStorage(state, storage){
            state.storage = storage;
        },
        setIngredientsList(state, data){
            state.storage[data.index].ingredients = data.ingredients;
        },
        setVisibleStorage(state, data){
             state.visibleStorage = data;
        },
        setVisibleStorageIngredients(state, data){
             state.visibleStorage.ingredients = data;
        },
        setActiveStorageId(state, data){
             state.activeStorageId = data;
        },
        setDataToSend(state, data){
             state.dataToSend = data;
        },
    },
    actions: {

    },
    getters: {
        getStorage: (state) => {
            return state.storage;
        },
        name: (state) => {
            return state.storageInfo.storageType.key;
        },
        ingredientsList: (state) => {
            return state.visibleStorage.ingredients;
        },
        id: (state) => {
            return state.storageInfo.storageType.id;
        },
        visibleStorage: (state) => {
            return state.visibleStorage;
        },
        activeStorageId: (state) => {
            return state.activeStorageId;
        },
        dataToSend: (state) => {
            return state.dataToSend;
        },
    },
    modules:{

    }
    
}